import api from "@/api/api";

export default {
  index(params = {}) {
    return api.get("main/reminders", { params });
  },
  store(payload) {
    return api.post("main/reminders", payload);
  },
  update(id, payload) {
    return api.put(`main/reminders/${id}`, payload);
  },
  destroy(id) {
    return api.delete(`main/reminders/${id}`);
  },
  snooze(id, duration) {
    return api.post(`main/reminders/${id}/snooze`, { duration });
  },
};
